import { HomePage } from './../../home/home';
import { CarieklePage } from './../cariekle/cariekle';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams, ModalController, ViewController } from 'ionic-angular';

/**
 * Generated class for the CarisecmodalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-carisecmodal',
  templateUrl: 'carisecmodal.html',
})
export class CarisecmodalPage {
  cariListesi = [];
  aranan = "";
  skip: number = 0;
  take: number = 50;

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public modalCtrl:ModalController,
    public view:ViewController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.cariAra(null);
  }
  cariAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "CariListesi", "", false).then(a => {

      var sonuc = <any>a;
      this.cariListesi = sonuc.SonucObject;


    })
  }
  cariler(e) {

    if (e.keyCode == 13) {
      this.cariAra(e);
    }
  }
  yeni() {
    let modal = this.modalCtrl.create(CarieklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  CariGuncelle(kisi) {
    let modal = this.modalCtrl.create(CarieklePage, { vwCari: kisi });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();

  }
  musteriSec(Cari) {
    this.view.dismiss(Cari);
  }
  kapat() {
    this.navCtrl.setRoot(HomePage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/carisecmodal/carisecmodal.ts